export default __webpack_public_path__ + "static/banner-media-release-sep11-26c8f825cdaa50a640ef310d4b832f00.jpg";